var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-ne-template-message-form" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("whatsapp_business_api.createNewTemplate"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex gap-5" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", ghost: "" },
              on: { click: _vm.viewTemplates },
            },
            [
              _c("a-icon", { attrs: { type: "back" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("whatsapp_business_api.viewTemplates")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "template-message-form-container" }, [
      _c("div", { staticClass: "inputs" }, [
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-header" },
              [
                _c("label", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("whatsapp_business_api.templateName")) +
                      "\n                        "
                  ),
                  _c("span", { staticClass: "required" }, [
                    _vm._v(_vm._s(_vm.$t("message.required"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-icon", { attrs: { type: "question-circle" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(
                _vm._s(_vm.$t("whatsapp_business_api.templateNameDesc")) + " "
              ),
            ]),
            _vm._v(" "),
            _c("a-input", {
              ref: "elementNameInput",
              class: { error: _vm.elementNameError },
              model: {
                value: _vm.form.elementName,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "elementName", $$v)
                },
                expression: "form.elementName",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "input-desc" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("whatsapp_business_api.templateNameRules")) +
                  "\n                "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-header" },
            [
              _c("label", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("whatsapp_business_api.category")) +
                    "\n                        "
                ),
                _c("span", { staticClass: "required" }, [
                  _vm._v(_vm._s(_vm.$t("message.required"))),
                ]),
              ]),
              _vm._v(" "),
              _c("a-icon", { attrs: { type: "question-circle" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.$t("whatsapp_business_api.categoryDesc"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "categories" },
            _vm._l(_vm.categories, function (category) {
              return _c(
                "div",
                {
                  key: category.id,
                  staticClass: "category",
                  on: {
                    click: function ($event) {
                      _vm.form.category = category.id
                    },
                  },
                },
                [
                  _c("div", { staticClass: "category-header" }, [
                    _c("div", { staticClass: "left" }, [
                      _vm.form.category === category.id
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v(
                              "\n                                    radio_button_checked\n                                "
                            ),
                          ])
                        : _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" radio_button_unchecked "),
                          ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(category.label)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" " + _vm._s(category.icon) + " "),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "category-description" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(category.description) +
                        "\n                        "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.categories.find(function (c) {
            return c.id === _vm.form.category
          }).types.length > 0
            ? _c(
                "div",
                { staticClass: "category-types" },
                _vm._l(
                  _vm.categories.find(function (c) {
                    return c.id === _vm.form.category
                  }).types,
                  function (categoryType) {
                    return _c(
                      "div",
                      {
                        staticClass: "category-type",
                        on: {
                          click: function ($event) {
                            return _vm.selectTemplateType(categoryType)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "category-type-header" }, [
                          _c("div", { staticClass: "left" }, [
                            _vm.form.templateType === categoryType
                              ? _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    "\n                                    radio_button_checked\n                                "
                                  ),
                                ])
                              : _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" radio_button_unchecked "),
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(
                                _vm._s(_vm.categoryTypes[categoryType].label)
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "category-type-description" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.categoryTypes[categoryType].description
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-header" },
              [
                _c("label", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("settings.language")) +
                      "\n                        "
                  ),
                  _c("span", { staticClass: "required" }, [
                    _vm._v(_vm._s(_vm.$t("message.required"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-icon", { attrs: { type: "question-circle" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.languageDesc"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.form.languageCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "languageCode", $$v)
                  },
                  expression: "form.languageCode",
                },
              },
              _vm._l(_vm.languages, function (language) {
                return _c(
                  "a-select-option",
                  { key: language.code, attrs: { value: language.code } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(language.label) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.templateType === "CUSTOM_MESSAGE"
          ? _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "input-header" },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("whatsapp_business_api.header")) +
                          "\n                        "
                      ),
                      _c("span", { staticClass: "optional" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.optional"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-icon", { attrs: { type: "question-circle" } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("whatsapp_business_api.headerRules")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex gap-10" },
                  [
                    _c("label", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.headerType"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.form.customMessageType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customMessageType", $$v)
                          },
                          expression: "form.customMessageType",
                        },
                      },
                      _vm._l(_vm.customMessageTypes, function (templateType) {
                        return _c(
                          "a-select-option",
                          {
                            key: templateType.id,
                            attrs: { value: templateType.id },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(templateType.label) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.customMessageType === "TEXT"
                  ? [
                      _c(
                        "div",
                        { staticClass: "d-flex gap-10" },
                        [
                          _c("label", { staticStyle: { width: "100px" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("whatsapp_business_api.headerText"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "whatsapp_business_api.header"
                              ),
                              "max-length": 60,
                            },
                            on: { input: _vm.headerChanged },
                            model: {
                              value: _vm.form.header,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "header", $$v)
                              },
                              expression: "form.header",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-footer" }, [
                        _c("div", { staticClass: "counter" }, [
                          _c("span", [
                            _vm._v(_vm._s((_vm.form.header || "").length)),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("/")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("60")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.headerVariables.length
                        ? _c("div", { staticClass: "variables-container" }, [
                            _c(
                              "div",
                              { staticClass: "labels" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("whatsapp_business_api.variables")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("label", { attrs: { id: "labelSecond" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.defaultVariableName"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom-end' }",
                                    },
                                  ],
                                  staticStyle: { cursor: "default" },
                                  attrs: {
                                    type: "question-circle",
                                    content: _vm.$t(
                                      "whatsapp_business_api.defaultVariableToolTip"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "variables" },
                              _vm._l(
                                _vm.headerVariables,
                                function (variable, i) {
                                  return _c(
                                    "div",
                                    { staticClass: "variable" },
                                    [
                                      _c("a-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "whatsapp_business_api.variable"
                                          ),
                                          disabled: true,
                                        },
                                        model: {
                                          value:
                                            _vm.headerVariables[i].variable,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.headerVariables[i],
                                              "variable",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "headerVariables[i].variable",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("a-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "whatsapp_business_api.example"
                                          ),
                                        },
                                        model: {
                                          value: _vm.headerVariables[i].example,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.headerVariables[i],
                                              "example",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "headerVariables[i].example",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "add-variable-button" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", ghost: "" },
                              on: { click: _vm.addHeaderVariable },
                            },
                            [
                              _c("a-icon", { attrs: { type: "plus" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("whatsapp_business_api.addVariable")
                                  ) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.templateType === "CUSTOM_MESSAGE" &&
        ["IMAGE", "VIDEO", "DOCUMENT"].includes(_vm.form.customMessageType)
          ? _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "div",
                { staticClass: "input-header" },
                [
                  _c("label", [
                    _vm._v(
                      "\n                        Media\n                        "
                    ),
                    _c("span", { staticClass: "optional" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp_business_api.optional"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-icon", { attrs: { type: "question-circle" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.media
                ? _c("div", { staticClass: "media-preview" }, [
                    _c("div", { staticClass: "media-preview-content" }, [
                      _c("div", { staticClass: "media-image" }, [
                        _c("img", { attrs: { src: _vm.media.data, alt: "" } }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "media-preview-name" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.media.name) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "media-preview-delete",
                        on: {
                          click: function ($event) {
                            _vm.media = null
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "media-drag" }, [
                    _c("div", { staticClass: "input" }, [
                      _c("input", {
                        attrs: {
                          type: "file",
                          id: "media-source",
                          accept:
                            "image/jpeg, image/png, video/mp4, application/pdf",
                        },
                        on: { change: _vm.handleFileUpload },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("image"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v("Click here to upload a picture."),
                    ]),
                  ]),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-header" },
              [
                _c("label", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("whatsapp_business_api.body")) +
                      "\n                        "
                  ),
                  _c("span", { staticClass: "required" }, [
                    _vm._v(_vm._s(_vm.$t("message.required"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-icon", { attrs: { type: "question-circle" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.bodyRules")) + "."),
            ]),
            _vm._v(" "),
            _c("a-textarea", {
              attrs: {
                "auto-size": { minRows: 1, maxRows: 15 },
                "max-length": 1024,
              },
              model: {
                value: _vm.form.content,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "content", $$v)
                },
                expression: "form.content",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-footer" }, [
              _c("div", { staticClass: "counter" }, [
                _c("span", [_vm._v(_vm._s(_vm.form.content.length))]),
                _vm._v(" "),
                _c("span", [_vm._v("/")]),
                _vm._v(" "),
                _c("span", [_vm._v("1024")]),
              ]),
            ]),
            _vm._v(" "),
            _vm.bodyVariables.length
              ? _c("div", { staticClass: "variables-container" }, [
                  _c(
                    "div",
                    { staticClass: "labels" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.variables"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", { attrs: { id: "labelSecond" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("whatsapp_business_api.defaultVariableName")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-icon", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticStyle: { cursor: "default" },
                        attrs: {
                          type: "question-circle",
                          content: _vm.$t(
                            "whatsapp_business_api.defaultVariableToolTip"
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "variables" },
                    _vm._l(_vm.bodyVariables, function (variable, i) {
                      return _c(
                        "div",
                        { staticClass: "variable" },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "whatsapp_business_api.variable"
                              ),
                              disabled: true,
                            },
                            model: {
                              value: _vm.bodyVariables[i].variable,
                              callback: function ($$v) {
                                _vm.$set(_vm.bodyVariables[i], "variable", $$v)
                              },
                              expression: "bodyVariables[i].variable",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "whatsapp_business_api.example"
                              ),
                            },
                            model: {
                              value: _vm.bodyVariables[i].example,
                              callback: function ($$v) {
                                _vm.$set(_vm.bodyVariables[i], "example", $$v)
                              },
                              expression: "bodyVariables[i].example",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-variable-button" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", ghost: "" },
                    on: { click: _vm.addVariable },
                  },
                  [
                    _c("a-icon", { attrs: { type: "plus" } }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("whatsapp_business_api.addVariable")) +
                        "\n                    "
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.templateType === "CUSTOM_MESSAGE"
          ? _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "input-header" },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("whatsapp_business_api.footer")) +
                          "\n                        "
                      ),
                      _c("span", { staticClass: "optional" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.optional"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-icon", { attrs: { type: "question-circle" } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("whatsapp_business_api.footerDesc")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  attrs: { placeholder: "Footer", "max-length": 60 },
                  model: {
                    value: _vm.form.footer,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "footer", $$v)
                    },
                    expression: "form.footer",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-footer" }, [
                  _c("div", { staticClass: "counter" }, [
                    _c("span", [
                      _vm._v(_vm._s((_vm.form.footer || "").length)),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("/")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("60")]),
                  ]),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.templateType === "CUSTOM_MESSAGE"
          ? _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "input-header" },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("whatsapp_business_api.buttons")) +
                          "\n                        "
                      ),
                      _c("span", { staticClass: "optional" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.optional"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-icon", { attrs: { type: "question-circle" } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex gap-10" },
                  [
                    _c("label", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.buttonType"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.form.buttonType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "buttonType", $$v)
                          },
                          expression: "form.buttonType",
                        },
                      },
                      _vm._l(_vm.buttonTypes, function (buttonType, index) {
                        return _c(
                          "a-select-option",
                          { key: index, attrs: { value: buttonType.id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(buttonType.label) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _vm.form.buttonType !== "NONE"
                  ? _c("div", { staticClass: "d-flex flex-column gap-10" }, [
                      _c(
                        "div",
                        { staticClass: "input-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                ghost: "",
                                disabled: _vm.form.buttons.length >= 10,
                              },
                              on: { click: _vm.addButton },
                            },
                            [
                              _c("a-icon", { attrs: { type: "plus" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("whatsapp_business_api.addButton")
                                  ) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "counter" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.form.buttons.length)),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("/")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("10")]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-warn" }, [
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$t("userInfoWidget.note")) + ": "
                            ),
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("message.templateButtonNote")) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "list-item" }, [
                          _c("li", [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$t("message.templateButtonTags"))
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "button-container" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("whatsapp_business_api.buttons"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "button-management" }, [
                          _c("div", { staticClass: "button-preview-section" }, [
                            _c(
                              "div",
                              { staticClass: "button-previews" },
                              [
                                _c(
                                  "draggable",
                                  {
                                    attrs: { handle: ".drag-handle" },
                                    on: { end: _vm.onButtonDragEnd },
                                    model: {
                                      value: _vm.form.buttons,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "buttons", $$v)
                                      },
                                      expression: "form.buttons",
                                    },
                                  },
                                  _vm._l(
                                    _vm.form.buttons,
                                    function (button, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          class: [
                                            "button-preview-item",
                                            {
                                              active:
                                                _vm.selectedButtonIndex ===
                                                index,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedButtonIndex = index
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "button-preview" },
                                            [
                                              _c(
                                                "supsis-button",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(0, 165, 244)",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        button.text ||
                                                          "Button " +
                                                            (index + 1)
                                                      ) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "button-type-badge",
                                                },
                                                [_vm._v(_vm._s(button.type))]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "button-preview-actions",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons drag-handle",
                                                },
                                                [_vm._v("drag_indicator")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons remove-button",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeButtonList(
                                                        button
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("close")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.form.buttons.length > 0 &&
                          _vm.selectedButtonIndex >= 0
                            ? _c(
                                "div",
                                { staticClass: "button-config-section" },
                                [
                                  _c("div", { staticClass: "config-header" }, [
                                    _c("h3", [
                                      _vm._v(
                                        "Configure Button " +
                                          _vm._s(_vm.selectedButtonIndex + 1)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "button-type" }, [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.form.buttons[
                                            _vm.selectedButtonIndex
                                          ] &&
                                            _vm.form.buttons[
                                              _vm.selectedButtonIndex
                                            ].type) ||
                                            "Unknown"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.form.buttons[_vm.selectedButtonIndex] &&
                                  _vm.form.buttons[_vm.selectedButtonIndex]
                                    .type === "URL"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "button-config-form" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "config-grid" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "config-field",
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v("Button Text"),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("a-input", {
                                                      attrs: {
                                                        placeholder:
                                                          "Enter button text",
                                                        "max-length": 25,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.buttons[
                                                            _vm
                                                              .selectedButtonIndex
                                                          ].text,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.buttons[
                                                              _vm
                                                                .selectedButtonIndex
                                                            ],
                                                            "text",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.buttons[selectedButtonIndex].text",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            (_vm.form.buttons[
                                                              _vm
                                                                .selectedButtonIndex
                                                            ].text &&
                                                              _vm.form.buttons[
                                                                _vm
                                                                  .selectedButtonIndex
                                                              ].text.length) ||
                                                              0
                                                          ) + "/25"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "config-field",
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v("Select URL type"),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-select",
                                                      {
                                                        model: {
                                                          value:
                                                            _vm.form.buttons[
                                                              _vm
                                                                .selectedButtonIndex
                                                            ].urlType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form.buttons[
                                                                _vm
                                                                  .selectedButtonIndex
                                                              ],
                                                              "urlType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.buttons[selectedButtonIndex].urlType",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a-select-option",
                                                          {
                                                            attrs: {
                                                              value: "STATIC",
                                                            },
                                                          },
                                                          [_vm._v("Static")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a-select-option",
                                                          {
                                                            attrs: {
                                                              value: "DYNAMIC",
                                                            },
                                                          },
                                                          [_vm._v("Dynamic")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "config-field" },
                                              [
                                                _c("label", [
                                                  _vm._v("Button Value"),
                                                ]),
                                                _vm._v(" "),
                                                _vm.form.buttons[
                                                  _vm.selectedButtonIndex
                                                ].urlType === "STATIC"
                                                  ? _c("a-input", {
                                                      attrs: {
                                                        placeholder:
                                                          "https://supsis.com/",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.buttons[
                                                            _vm
                                                              .selectedButtonIndex
                                                          ].url,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.buttons[
                                                              _vm
                                                                .selectedButtonIndex
                                                            ],
                                                            "url",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.buttons[selectedButtonIndex].url",
                                                      },
                                                    })
                                                  : _c("a-input", {
                                                      attrs: {
                                                        placeholder:
                                                          "https://supsis.com/",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.buttons[
                                                            _vm
                                                              .selectedButtonIndex
                                                          ].buttonValue,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.buttons[
                                                              _vm
                                                                .selectedButtonIndex
                                                            ],
                                                            "buttonValue",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.buttons[selectedButtonIndex].buttonValue",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.form.buttons[
                                              _vm.selectedButtonIndex
                                            ].urlType === "DYNAMIC"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dynamic-config",
                                                  },
                                                  [
                                                    _vm._m(1),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dynamic-input-group",
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "variable-tag",
                                                          domProps: {
                                                            textContent:
                                                              _vm._s("{{1}}"),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("a-input", {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                          attrs: {
                                                            placeholder: "test",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.buttons[
                                                                _vm
                                                                  .selectedButtonIndex
                                                              ].suffix,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form
                                                                  .buttons[
                                                                  _vm
                                                                    .selectedButtonIndex
                                                                ],
                                                                "suffix",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.buttons[selectedButtonIndex].suffix",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.buttons[_vm.selectedButtonIndex] &&
                                  _vm.form.buttons[_vm.selectedButtonIndex]
                                    .type === "PHONE_NUMBER"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "button-config-form" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "config-field" },
                                              [
                                                _c("label", [
                                                  _vm._v("Button Text"),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder: "Call Us",
                                                    "max-length": 25,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.buttons[
                                                        _vm.selectedButtonIndex
                                                      ].text,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form.buttons[
                                                          _vm
                                                            .selectedButtonIndex
                                                        ],
                                                        "text",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.buttons[selectedButtonIndex].text",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "field-info" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (_vm.form.buttons[
                                                          _vm
                                                            .selectedButtonIndex
                                                        ].text &&
                                                          _vm.form.buttons[
                                                            _vm
                                                              .selectedButtonIndex
                                                          ].text.length) ||
                                                          0
                                                      ) + "/25"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "config-field" },
                                              [
                                                _c("label", [
                                                  _vm._v("Phone Number"),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "Phone Number (only digits)",
                                                    type: "tel",
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.handlePhoneNumberInput(
                                                        _vm.selectedButtonIndex
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.buttons[
                                                        _vm.selectedButtonIndex
                                                      ].phone_number,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form.buttons[
                                                          _vm
                                                            .selectedButtonIndex
                                                        ],
                                                        "phone_number",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.buttons[selectedButtonIndex].phone_number",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "field-info" },
                                                  [
                                                    _vm._v(
                                                      "Only numbers allowed, max 15 digits"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.buttons[_vm.selectedButtonIndex] &&
                                  _vm.form.buttons[_vm.selectedButtonIndex]
                                    .type === "QUICK_REPLY"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "button-config-form" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "config-field" },
                                              [
                                                _c("label", [
                                                  _vm._v("Button Text"),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder: "Quick Reply",
                                                    "max-length": 25,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.buttons[
                                                        _vm.selectedButtonIndex
                                                      ].text,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form.buttons[
                                                          _vm
                                                            .selectedButtonIndex
                                                        ],
                                                        "text",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.buttons[selectedButtonIndex].text",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "field-info" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (_vm.form.buttons[
                                                          _vm
                                                            .selectedButtonIndex
                                                        ].text &&
                                                          _vm.form.buttons[
                                                            _vm
                                                              .selectedButtonIndex
                                                          ].text.length) ||
                                                          0
                                                      ) + "/25"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.templateType === "CAROUSEL"
          ? _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "div",
                { staticClass: "input-header" },
                [
                  _c("label", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("auto.gupshupCarousel")) +
                        "\n                        "
                    ),
                    _c("span", { staticClass: "required" }, [
                      _vm._v(_vm._s(_vm.$t("message.required"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-icon", { attrs: { type: "question-circle" } }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.$t("auto.gupshupCarouselDesc"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "global-settings" }, [
                _c(
                  "div",
                  { staticClass: "media-type-section" },
                  [
                    _c("div", { staticClass: "section-header" }, [
                      _c("label", [_vm._v("Media Type")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [
                        _vm._v(_vm._s(_vm.$t("message.required"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        on: { change: _vm.handleMediaTypeChange },
                        model: {
                          value: _vm.carouselMediaType,
                          callback: function ($$v) {
                            _vm.carouselMediaType = $$v
                          },
                          expression: "carouselMediaType",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "IMAGE" } }, [
                          _vm._v("Image"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "VIDEO" } }, [
                          _vm._v("Video"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(2),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-config-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("label", [_vm._v("Buttons Configuration")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "optional" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp_business_api.optional"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-config" },
                    [
                      _vm._l(_vm.carouselButtons, function (button, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "button-type-config" },
                          [
                            _c(
                              "div",
                              { staticClass: "button-type" },
                              [
                                _c("label", { staticClass: "button-label" }, [
                                  _vm._v(
                                    "Button " + _vm._s(index + 1) + " Type"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    on: { change: _vm.updateCardButtons },
                                    model: {
                                      value: button.type,
                                      callback: function ($$v) {
                                        _vm.$set(button, "type", $$v)
                                      },
                                      expression: "button.type",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "QUICK_REPLY" } },
                                      [_vm._v("Quick Reply")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "URL" } },
                                      [_vm._v("URL")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            index === _vm.carouselButtons.length - 1
                              ? _c(
                                  "div",
                                  { staticClass: "button-delete" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "link",
                                          disabled:
                                            _vm.carouselButtons.length === 0,
                                        },
                                        on: { click: _vm.removeGlobalButton },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "delete" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-add" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                disabled: _vm.carouselButtons.length >= 2,
                                type: "primary",
                                ghost: "",
                              },
                              on: { click: _vm.addGlobalButton },
                            },
                            [
                              _c("a-icon", { attrs: { type: "plus" } }),
                              _vm._v(
                                "\n                                    Add Button\n                                "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "counter" }, [
                            _vm._v(
                              _vm._s(_vm.carouselButtons.length) + "/2 buttons"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "carousel-cards-section" },
                [
                  _c(
                    "draggable",
                    {
                      attrs: { handle: ".drag-handle" },
                      model: {
                        value: _vm.carouselCards,
                        callback: function ($$v) {
                          _vm.carouselCards = $$v
                        },
                        expression: "carouselCards",
                      },
                    },
                    _vm._l(_vm.carouselCards, function (card, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "carousel-card" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCard(index)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "left" }, [
                                _c("span", { staticClass: "drag-handle" }, [
                                  _vm._v("☰"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "carousel-card-heading" },
                                  [_vm._v("Card " + _vm._s(index + 1))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "right" },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticClass: "delete-btn",
                                      attrs: {
                                        type: "link",
                                        disabled:
                                          _vm.carouselCards.length === 1,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.removeCard(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("a-icon", {
                                    attrs: {
                                      type: card.isOpen ? "up" : "down",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: card.isOpen,
                                  expression: "card.isOpen",
                                },
                              ],
                              staticClass: "card-content",
                            },
                            [
                              _c("div", { staticClass: "media-section" }, [
                                _c("div", { staticClass: "media-upload" }, [
                                  card.media
                                    ? _c(
                                        "div",
                                        { staticClass: "media-preview" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "media-preview-content",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "media-image" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: card.media.data,
                                                      alt: "",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-preview-name",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(card.media.name) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "media-preview-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCardMedia(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("close")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("div", { staticClass: "media-drag" }, [
                                        _c("div", { staticClass: "input" }, [
                                          _c("input", {
                                            attrs: {
                                              type: "file",
                                              accept: _vm.getAcceptedFileTypes(
                                                _vm.carouselMediaType
                                              ),
                                            },
                                            on: {
                                              change: function (event) {
                                                return _vm.handleCardMediaUpload(
                                                  event,
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("image")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "content" }, [
                                          _vm._v(
                                            "\n                                                Click here to upload " +
                                              _vm._s(
                                                _vm.carouselMediaType.toLowerCase()
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]),
                                      ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "description-section" },
                                [
                                  _c("div", { staticClass: "section-header" }, [
                                    _c("label", [_vm._v("Description")]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "required" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.required"))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-textarea", {
                                    attrs: {
                                      "auto-size": { minRows: 2, maxRows: 4 },
                                      maxLength: 160,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.cardBodyChanged(index)
                                      },
                                    },
                                    model: {
                                      value: card.body,
                                      callback: function ($$v) {
                                        _vm.$set(card, "body", $$v)
                                      },
                                      expression: "card.body",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "description-footer" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(card.body.length) + "/160"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  card.variables.length
                                    ? _c(
                                        "div",
                                        { staticClass: "variables-container" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "variables" },
                                            _vm._l(
                                              card.variables,
                                              function (variable, i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: i,
                                                    staticClass: "variable",
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      attrs: { disabled: true },
                                                      model: {
                                                        value:
                                                          card.variables[i]
                                                            .variable,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            card.variables[i],
                                                            "variable",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "card.variables[i].variable",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("a-input", {
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "whatsapp_business_api.example"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          card.variables[i]
                                                            .example,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            card.variables[i],
                                                            "example",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "card.variables[i].example",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "variable-button" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary", ghost: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addCardVariable(index)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "plus" },
                                          }),
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "whatsapp_business_api.addVariable"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.carouselButtons.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "buttons-section" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "button-list" },
                                        _vm._l(
                                          card.buttons,
                                          function (button, buttonIndex) {
                                            return _c(
                                              "div",
                                              {
                                                key: buttonIndex,
                                                staticClass: "button-item",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "button-inputs-row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group",
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v("Select type"),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("a-input", {
                                                          attrs: {
                                                            value: button.type,
                                                            disabled: "",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group",
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v(
                                                            "Button Title"
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("a-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "Button " +
                                                              (buttonIndex +
                                                                1) +
                                                              " Text",
                                                          },
                                                          model: {
                                                            value: button.text,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                button,
                                                                "text",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "button.text",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    button.type === "URL"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group",
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Select URL type"
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a-select",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                model: {
                                                                  value:
                                                                    button.urlType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        button,
                                                                        "urlType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "button.urlType",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "a-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        "STATIC",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Static"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        "DYNAMIC",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Dynamic"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    button.type === "URL"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group",
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Button Value"
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            button.urlType ===
                                                            "STATIC"
                                                              ? _c("a-input", {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Enter static URL",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      button.url,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          button,
                                                                          "url",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "button.url",
                                                                  },
                                                                })
                                                              : _c("a-input", {
                                                                  model: {
                                                                    value:
                                                                      button.buttonValue,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          button,
                                                                          "buttonValue",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "button.buttonValue",
                                                                  },
                                                                }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                button.type === "URL" &&
                                                button.urlType === "DYNAMIC"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "button-inputs-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "sample-url-section",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sample-url-inputs",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "\n                                                            " +
                                                                      _vm._s(
                                                                        "{" +
                                                                          "{" +
                                                                          "1" +
                                                                          "}" +
                                                                          "}"
                                                                      ) +
                                                                      "\n                                                        "
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("a-input", {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Type Sample Suffix",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      button.suffix,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          button,
                                                                          "suffix",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "button.suffix",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "carousel-actions" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.carouselCards.length >= 10,
                        ghost: "",
                      },
                      on: { click: _vm.addCard },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v(
                        "\n                        Add Card\n                    "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "counter" }, [
                    _vm._v(_vm._s(_vm.carouselCards.length) + "/10 cards"),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions d-flex flex-end w-100" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", disabled: _vm.submitting },
                on: { click: _vm.submit },
              },
              [
                _c("a-icon", { attrs: { type: "save" } }),
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.submitting
                        ? _vm.$t("whatsapp_business_api.submitting")
                        : _vm.$t("whatsapp_business_api.submit")
                    ) +
                    "\n                "
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "div",
          { staticClass: "preview-container" },
          [
            _c("WhatsappMessagePreview", {
              attrs: {
                body: _vm.getExampleBodyContent(
                  _vm.form.content,
                  _vm.bodyVariables
                ),
                footer: _vm.form.footer,
                "template-type": _vm.form.templateType,
                "header-media-type": _vm.form.customMessageType,
                "header-text": _vm.getExampleBodyContent(
                  _vm.form.header,
                  _vm.headerVariables
                ),
                buttons: _vm.form.buttons,
                cards: _vm.formatCards(),
                headerMediaURL: _vm.media && _vm.media.asset.url,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "description" }, [
      _c("div", { staticClass: "input-warn" }, [
        _c("div", [
          _c("b", [_vm._v("Note:")]),
          _vm._v(
            "Following are the file formats and their respective sizes which are accepted\n                            for upload\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "list-item" }, [
          _c("li", [_vm._v("Image: JPEG and PNG (Max size 2 MB)")]),
          _vm._v(" "),
          _c("li", [_vm._v("Video: MP4 (Max size 20 MB)")]),
          _vm._v(" "),
          _c("li", [_vm._v("Document: (Max size 2 MB)")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dynamic-info" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "description" }, [
      _c("div", { staticClass: "input-warn" }, [
        _c("div", [
          _c("b", [_vm._v("Note:")]),
          _vm._v(
            " All cards will use the same media type. Supported formats and\n                                    sizes:\n                                "
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "list-item" }, [
          _c("li", [_vm._v("Image: JPEG and PNG (Max size 2 MB)")]),
          _vm._v(" "),
          _c("li", [_vm._v("Video: MP4 (Max size 20 MB)")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }